<div class="error">
  <sn-icon class="error__icon large-bottom-margin">cancel</sn-icon>
  <h1 class="large-bottom-margin">Fusus Server can't be reached.</h1>
  <p class="connection-refused__try">Try:</p>
  <h3>Checking the internet connection</h3>
  <h3>Checking the proxy and the firewall</h3>
  <button
    mat-raised-button
    color="primary"
    class="retryButton"
    matTooltip="Retry Connection"
    matTooltipPosition="before"
    (click)="goToMap()"
  >
    Retry Connection
    <sn-icon>autorenew</sn-icon>
  </button>
</div>
